<div class="open-and-closed-revenues">
  <!-- Filters Row (Horizontal) -->
  @if (isFilterVisible) {
    <div class="filters-row">
      <div class="horizontal-filters-container">
        <!-- Date Range Filter -->
        <div class="filter-item">
          <label>Date Range</label>
          <div class="calendar-container">
            <p-calendar
              [(ngModel)]="dateRangeValue"
              selectionMode="range"
              [readonlyInput]="true"
              [showIcon]="true"
              [minDate]="minDateValue"
              [maxDate]="maxDateValue"
              dateFormat="mm/dd/yy"
              placeholder="Select date range"
              [style]="{'width':'100%'}"
              [yearNavigator]="true"
              [monthNavigator]="true"
              yearRange="2020:2050">
            </p-calendar>
          </div>
        </div>
        <!-- Organization Filter -->
        <div class="filter-item">
          <label>Organization</label>
          <ng-select
            [items]="organizationOptions"
            bindLabel="name"
            bindValue="name"
            placeholder="Select organization"
            [(ngModel)]="selectedOrganization"
            (change)="onOrganizationChange($event)"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Matter Filter -->
        <div class="filter-item">
          <label>Matter</label>
          <ng-select
            [items]="matterOptions"
            bindLabel="name"
            bindValue="name"
            [placeholder]="selectedOrganization ? 'Select matter' : 'Select org first'"
            [(ngModel)]="selectedMatter"
            (change)="onMatterChange($event)"
            [clearable]="true"
            [disabled]="!selectedOrganization"
            class="custom-select multiline-dropdown">
            <ng-template ng-notfound-tmp>
              <div class="ng-option disabled">
                {{ selectedOrganization ? 'No matters found' : 'Please select an organization first' }}
              </div>
            </ng-template>
          </ng-select>
        </div>
        <!-- Practice Area Filter -->
        <div class="filter-item">
          <label>Practice Area</label>
          <ng-select
            [items]="practiceAreaOptions"
            bindLabel="name"
            bindValue="name"
            placeholder="Select practice area"
            [(ngModel)]="selectedPracticeArea"
            (change)="onPracticeAreaChange($event)"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Created By Filter -->
        <div class="filter-item">
          <label>Created By</label>
          <ng-select
            [items]="userOptions"
            bindLabel="name"
            bindValue="id"
            placeholder="Select user"
            [(ngModel)]="selectedUser"
            (change)="onUserChange($event)"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Apply and Clear Filters -->
        <div class="filter-actions">
          <button class="btn btn-primary apply-btn" (click)="applyAllFilters()">Apply</button>
          <button class="btn btn-outline-secondary clear-btn" (click)="clearAllFilters()">
            <i class="bx bx-x-circle"></i> Clear
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Chart Row -->
  <div class="row">
    <!-- Chart Column (Full Width) -->
    <div class="col-12 chart-column">
      <div #chartContainer class="chart-container">
        @if (isLoading) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
          </div>
        }
        @if (!isLoading) {
          <div class="revenue-cards-container">
            @for (item of data; track item; let i = $index) {
              <div class="revenue-card"
                [style.border-bottom-color]="colorScheme.domain[i % colorScheme.domain.length]">
                <div class="card-content">
                  <h4>{{item.name}}</h4>
                  <div class="revenue-value">{{formatCurrency(item.value)}}</div>
                  <div class="hours-value">{{item.hours | number:'1.1-1'}} hrs</div>
                </div>
              </div>
            }
            @if (data.length === 0) {
              <div class="no-data-message">
                No revenue data available for the selected filters.
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
